import axios from 'api/axios'

interface SetupWebhookPayload {
	url: string
	webhookToken: string
}

const setupWebhook = async (clientId: string, payload: SetupWebhookPayload) => {
	const { data } = await axios.post(
		`/v1/tsp/meta/waba/phone-number/webhook/setup?clientId=${clientId}`,
		payload
	)
	return data
}

export default setupWebhook
